export type { UseFastPass } from './useFastPass'
export { default, defaultState } from './useFastPass'
